import React from "react";
import { connect } from "react-redux";
import { guardarDatosPoliza } from "./flujo.act";

import PolizaForm from "./poliza.frm";

const mapState = (state) => {
	return {
		uid: state.global.uid,
		tid: state.global.tid
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		pasoSiguiente: () => {
			dispatch({ "type": "REGISTRO_PASO_SIGUIENTE" });
		},
		pasoAnterior: () => {
			dispatch({ "type": "REGISTRO_PASO_ANTERIOR" });
		},
		registrarDatos(sRamo, sPoliza, sInicioVigencia, sInicioVigenciaDate, sCertificado, sPlacas, sMotor) {
			dispatch(guardarDatosPoliza(sRamo, sPoliza, sInicioVigencia, sInicioVigenciaDate, sCertificado, sPlacas, sMotor));
		}
	};
};

class Datos extends React.Component {
	
	submit = (data) => {
		let $this = this;
		
		if(data.polizaReal && parseInt(data.poliza) != parseInt(data.polizaReal)){
			data.poliza = data.polizaReal;
		}

		$this.props.loader(true);
		return new Promise(resolve => {
			$this.props.registrarDatos(data.ramo, data.poliza, data.inicioVigenciaPoliza, data.inicioVigenciaPolizaDate, data.certificado, data.placas, data.motor);
			$this.props.pasoSiguiente();
			$this.props.loader(false);
			resolve();
		});
	}
	
	render() {
		return <PolizaForm onSubmit={this.submit} />;
	}
}

export default connect(mapState, mapDispatch)(Datos);


// WEBPACK FOOTER //
// ./src/registro/datosAlt.cmpt.js